import React from "react";
import Skeleton from 'react-loading-skeleton'

const CardLoader = ({ cardNumber }) => (
  Array(cardNumber).fill().map((item, index) => (
    <div key={`card_${index}`} className="views-row">
      <div className="image-block">
        <div className="image">
          <Skeleton height={176} />
        </div>
      </div>
      <div className="site-informations">
        <h3>
          <Skeleton count={2} />
        </h3>
        <div className="site-name">
          <p>
            <Skeleton count={1} />
          </p>
        </div>
        <div className="information-block">
          <small>
            <Skeleton count={1} />
          </small>
        </div>
      </div>
    </div>
  ))
);

export default CardLoader;
